/**
 * Escrituras de la lección teacher-2 (reverencia y servicio). Texto de churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const teacher2TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-121-43-44',
    reference: 'Doctrina y Convenios 121:43–44',
    text:
      'reprendiendo en el momento oportuno con severidad, cuando lo induzca el Espíritu Santo; y entonces demostrando mayor amor hacia el que has reprendido, no sea que te considere su enemigo; para que sepa que tu fidelidad es más fuerte que los lazos de la muerte.',
    verses: [
      {
        verse: 43,
        text: 'reprendiendo en el momento oportuno con severidad, cuando lo induzca el Espíritu Santo; y entonces demostrando mayor amor hacia el que has reprendido, no sea que te considere su enemigo;',
      },
      {
        verse: 44,
        text: 'para que sepa que tu fidelidad es más fuerte que los lazos de la muerte.',
      },
    ],
    context: 'Reprender con el Espíritu y luego mostrar mayor amor.',
  },
  {
    id: 'dc-20-53-54',
    reference: 'Doctrina y Convenios 20:53–54',
    text:
      'El deber del maestro es velar siempre por los miembros de la iglesia, y estar con ellos y fortalecerlos; y cuidar de que no haya iniquidad en la iglesia, ni aspereza entre uno y otro, ni mentiras, ni difamaciones, ni calumnias;',
    verses: [
      {
        verse: 53,
        text: 'El deber del maestro es velar siempre por los miembros de la iglesia, y estar con ellos y fortalecerlos;',
      },
      {
        verse: 54,
        text: 'y cuidar de que no haya iniquidad en la iglesia, ni aspereza entre uno y otro, ni mentiras, ni difamaciones, ni calumnias;',
      },
    ],
    context: 'Velar, fortalecer y preservar el espíritu de unidad en la rama.',
  },
  {
    id: 'matthew-5-16',
    reference: 'Mateo 5:16',
    text: 'Así alumbre vuestra luz delante de los hombres, para que vean vuestras buenas obras y glorifiquen a vuestro Padre que está en los cielos.',
    verses: [
      {
        verse: 16,
        text: 'Así alumbre vuestra luz delante de los hombres, para que vean vuestras buenas obras y glorifiquen a vuestro Padre que está en los cielos.',
      },
    ],
    context: 'Buenas obras visibles que glorifican al Padre.',
  },
  {
    id: 'philippians-2-3-4',
    reference: 'Filipenses 2:3–4',
    text:
      'Nada hagáis por contienda o por vanagloria; antes bien, con humildad, estimando cada uno a los demás como superiores a sí mismo; no mirando cada uno por lo suyo propio, sino cada cual también por lo de los otros.',
    verses: [
      {
        verse: 3,
        text: 'Nada hagáis por contienda o por vanagloria; antes bien, con humildad, estimando cada uno a los demás como superiores a sí mismo;',
      },
      {
        verse: 4,
        text: 'no mirando cada uno por lo suyo propio, sino cada cual también por lo de los otros.',
      },
    ],
    context: 'Humildad y mirar por el bien ajeno.',
  },
];
